import createInformesSectionPage from "./SectionPageFactory";

const InformesRRHHPage = createInformesSectionPage(
  "Recursos Humanos",
  "Centralizá reportes de asistencia, nóminas y métricas del personal."
);

export default InformesRRHHPage;
